// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessRegister_wrapper__AKY9-"};